module.exports = __webpack_public_path__ + "static/media/modeloPromissoria.e2991886.png";